import { PBJReportDto } from './../../model/pbjreport-dto';
import { PdfFileService } from './../../services/pdf-file.service';
import { DatePipe } from '@angular/common';
import { ExcelFileService } from './../../services/excel-file.service';
import { FileExportService } from './../../services/file-export.service';
import { ReportDateRangeDto } from './../../model/report-date-range-dto';
import { HttpclientService } from './../../services/httpclient.service';
import { MonthlyLocationDto } from './../../model/monthly-location-dto';
import { AppSettingService } from './../../services/app-setting.service';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { PoOrderByPipe } from 'src/app/pipes/po-order-by.pipe';
import { ReportDateRangeWrapperDto } from 'src/app/model/report-date-range-wrapper-dto';
import { PartnerDto } from 'src/app/model/partner-dto';
import { PoandPBJreportDto } from 'src/app/model/poand-pbjreport-dto';
import { PurchaseOrderReportDto } from 'src/app/model/purchase-order-report-dto';

@Component({
  selector: 'app-pband-jreport',
  templateUrl: './pband-jreport.component.html',
  styleUrls: ['./pband-jreport.component.css']
})
export class PBandJReportComponent implements OnInit {
  maxDatePbjr: moment.Moment;
  dateRangePbjr;
  dateRangePbjrStart;
  dateRangePbjrEnd;
  mlrExportModal: string;
  mlrSelectAllRowModal: boolean;
  public mlrloading: boolean;
  public paginationConfigurationPbjr;
  mlrPaginationcount = 25;
  pbjReportDtoList: PBJReportDto[];
  pbjReportDtoSelectedList: PBJReportDto[];
  selectedPbjReportDto: any = [];
  poReportDto: any = [];
  reportDateRangeDto: ReportDateRangeDto;
  numberofexecution = 0;
  clearMlrSelection: PBJReportDto[];
  sortArry: PBJReportDto[];
  isDateUpArrow: boolean;
  isDateDownArrow: boolean;
  isPoUpArrow: boolean;
  isPoDownArrow: boolean;
  isPoNobolUpArrow: boolean;
  isPoNobolDownArrow: boolean;
  isPoPartialUpArrow: boolean;
  isPoPartialDownArrow: boolean;
  isPoCompleteUpArrow: boolean;
  isPoCompleteDownArrow: boolean;
  isBolUpArrow: boolean;
  isBolDownArrow: boolean;
  isInvoiceUpArrow: boolean;
  isInvoiceDownArrow: boolean;
  isP2bUpArrow: boolean;
  isP2bDownArrow: boolean;
  isB2iUpArrow: boolean;
  isB2iDownArrow: boolean;
  isSumOfShippedQtyUpArrow: boolean;
  isSumOfShippedQtyDownArrow: boolean;
  re: ReportDateRangeWrapperDto;
  reportDateRanges: ReportDateRangeDto[] = [];
  partnerModal;
  partnerDtoList: PartnerDto[];

  poandPBJreportDto: PoandPBJreportDto;
  PBJreportDto: PoandPBJreportDto;
  poReportListDto: PoandPBJreportDto;

  poReportList: PurchaseOrderReportDto[];
  pPBJReportDtoList: PBJReportDto[];
  message: string;

  exportFileNameStr;
  pbjPodataFlag;
  exportFlag;


  constructor(public appSettingService: AppSettingService, private httpclientService: HttpclientService,
              public fileExportService: FileExportService, public excelFileService: ExcelFileService, public datePipe: DatePipe,
              public pdfFileService: PdfFileService, private pipe: PoOrderByPipe) { }

  ngOnInit() {
    this.partnerModal = -1;
   // this.getPartnerDataList();
    this.pbjReportDtoList = [];
    this.mlrExportModal = this.appSettingService.exportList[0];
    this.maxDatePbjr = moment().add(0, 'days');
    this.mlrExportModal = this.appSettingService.exportList[0];
    this.paginationConfigurationPbjr = { currentPage: '25 per page', itemsPerPage: '25' };
    this.dateRangePbjr = '';
    this.initialSortValue();
  }

  getPartnerDataList() {
    this.mlrloading = true;
    if (this.appSettingService.customerMSOGlobelList === null || this.appSettingService.customerMSOGlobelList === undefined ) {
      this.httpclientService.getCustomerListMSO().subscribe(
        data => {
          this.appSettingService.customerMSOGlobelList = data;
          this.partnerDtoList = data;
          this.mlrloading = false;
        }
      );

    //  console.log('Partner is null from backend' + this.appSettingService.customerMSOGlobelList);
      } else {
        this.partnerDtoList = this.appSettingService.customerMSOGlobelList;
        this.mlrloading = false;
      //  console.log('Partner is not null from frontend' + this.appSettingService.customerMSOGlobelList);
      }
  }

/****************************************************** Clear Selction Start ***************************************************/


exportFileName(){
  const year = this.datePipe.transform(new Date(), 'y');
  const month = this.datePipe.transform(new Date(), 'MM');
  const date = this.datePipe.transform(new Date(), 'd');
  const hour = this.datePipe.transform(new Date(), 'HH');
  const min = this.datePipe.transform(new Date(), 'mm');
  const sec = this.datePipe.transform(new Date(), 'ss');

  this.exportFileNameStr = 'PB&J Dashboard_' + year + '_' + month +  '_' + date +  '_' + hour +  '_' + min +  '_' + sec;


}

initialSortValue() {
this.isDateUpArrow = true;
this.isDateDownArrow = true;
this.isPoUpArrow = true;
this.isPoDownArrow = true;
this.isPoNobolUpArrow = true;
this.isPoNobolDownArrow = true;
this.isPoPartialUpArrow = true;
this.isPoPartialDownArrow = true;
this.isPoCompleteUpArrow = true;
this.isPoCompleteDownArrow = true;
this.isBolUpArrow = true;
this.isBolDownArrow = true;
this.isInvoiceUpArrow = true;
this.isInvoiceDownArrow = true;
this.isP2bUpArrow = true;
this.isP2bDownArrow = true;
this.isB2iUpArrow = true;
this.isB2iDownArrow = true;
this.isSumOfShippedQtyUpArrow = true;
this.isSumOfShippedQtyDownArrow = true;
}
  clearAllSelection() {
     this.mlrSelectAllRowModal = false;
     this.initialSortValue();
    // this.clearMlrSelection = [];
    // this.pbjReportDtoList.forEach(pdto => {
    //   pdto.rowCheck = false;
    //   this.clearMlrSelection.push(pdto);
    // });
    // this.pbjReportDtoList = this.clearMlrSelection;
  }
/****************************************************** Clear Selction End ***************************************************/



/****************************************************** Date Picker Block Start ***************************************************/

selectePartner() {
  this.pbjReportDtoList = [];
  if (this.partnerModal !== -1) {
    this.dateOnChangePbjr();
  }
}

// getFulfillmentreport() {
//   // this.re = '{"partnerId":7,"reportDateRanges":[{"start":"2019-09-01","end":"2019-09-01"},{"start":"2019-09-02","end":"2019-09-02"}]}';
//   if (this.partnerModal !== -1) {
//   this.mlrloading = true;
//   this.re = {
//      partnerId: this.partnerModal,
//      reportDateRanges: this.reportDateRanges,
//    };

//   this.httpclientService.getFullfillmentReport(this.re).subscribe(
//      data => {
//        this.fullfillmentDataList = data;
//        this.fullfillmentDataList = this.orderByPipe.transform(this.fullfillmentDataList, 'locationId', true);

//        this.fullfillmentDataList.forEach(pdto => {
//          this.mlrloading = false;
//      });

//      //  this.filterData = this.groupByPipe.transform(this.fullfillmentDataList, 'locationId');

//      }
//    );
//   }

//  }

dateOnChangePbjr() {
  this.exportFlag = false;
  this.pbjPodataFlag = false;
  this.fileExportService.selectedPbjReportData = [];
 // this.clearAllSelection();
  if (this.dateRangePbjr.dateRangePbjrStart !== undefined &&
    this.dateRangePbjr.dateRangePbjrStart !== null  ) {
    this.mlrloading = true;

    this.reportDateRanges = [{
            start: this.dateRangePbjr.dateRangePbjrStart.format('YYYY-MM-DD'),
            end: this.dateRangePbjr.dateRangePbjrEnd.format('YYYY-MM-DD'),
          },
    ];

    this.re = {
      partnerId: this.partnerModal,
      reportDateRanges: this.reportDateRanges,
    };
    this.poandPBJreportDto ={
      pPBJReportDtoList: this.pPBJReportDtoList,
      poReportList: this.poReportList,
      message: this.message
    };


    this.httpclientService.getPBandJReport(this.re).subscribe(
      data => {
        this.mlrloading = false;
        this.clearAllSelection();
        this.PBJreportDto = data;

        this.pbjReportDtoList = this.PBJreportDto.pPBJReportDtoList;
        this.poandPBJreportDto.pPBJReportDtoList = this.PBJreportDto.pPBJReportDtoList;
        this.message = this.PBJreportDto.message;
      }

    );


    this.httpclientService.getPBandJpoReport(this.re).subscribe(
      data => {
        this.mlrloading = false;
        this.clearAllSelection();
        this.PBJreportDto = data;
        this.pbjPodataFlag = true;

        this.poandPBJreportDto.poReportList = this.PBJreportDto.poReportList;

        if(this.exportFlag){
          this.exportFileOnChangePbjr();
        }
      }

    );


  }
}
/****************************************************** Date Picker Block End ***************************************************/


/****************************************************** File Export Start ***************************************************/
modalPopup : boolean=false;
modalPopupString: string;
pressingOK(){
  this.modalPopup=false;
}

exportFileOnChangePbjr() {

  // if (this.fileExportService.selectedPbjReportData.length === 0) {
  //   this.modalPopupString="No Data to Export";
  //   this.modalPopup=true;
  // } else {

    this.exportFlag = true;

    if(!this.pbjPodataFlag){
      this.mlrloading =true;
    } else {
    if ( this.poandPBJreportDto === undefined || this.poandPBJreportDto === null || this.poandPBJreportDto.pPBJReportDtoList.length === 0) {
      this.modalPopupString = 'No Data to Export';
      this.modalPopup = true;
      return;
     } else if (this.fileExportService.selectedPbjReportData.length === 0 && this.poandPBJreportDto.pPBJReportDtoList.length !== 0) {

 if (this.mlrExportModal === 'PDF') {
  this.exportFileName();
  this.pdfFileService.exportPbjDashboardAll(this.exportFileNameStr, this.poandPBJreportDto);
       } else if (this.mlrExportModal === 'Excel') {
 this.selectedPbjReportDto = [];
 this.poandPBJreportDto.pPBJReportDtoList.forEach(pdto => {

          let createDateTime: any;
          createDateTime = this.datePipe.transform(pdto.dateOfCount, this.appSettingService.globelDateFormat);
          this.selectedPbjReportDto.push({
             Date: `` + createDateTime, PO: `${pdto.repCountofPO}`,
             'BoL' : `${pdto.repCountBol}`,
             Invoice : `${pdto.repCountInvoice}`, P2B : `${pdto.repCountBolNotReceived}`,
             B2I : `${pdto.repCountB2I}`, 'Sum of Shipped Qty 0' : `${pdto.repCountShippedZero}`,
           });
       });
 this.poReportDto = [];
 this.poandPBJreportDto.poReportList.forEach(pdto => {
        let createDateTime: any;
        let bolDate: any;
        let bol: any;
        let invoiceNumber: any;
        let shippedQty: any;
        let msoPayerAccount: any;

        if (pdto.supplierDocReferenceNumber === null) {
          bol = '';
       } else {
        bol = pdto.supplierDocReferenceNumber;
       }

        if (pdto.invoiceNumber === null) {
        invoiceNumber = '';
      } else {
        invoiceNumber = pdto.invoiceNumber;
      }

        if (pdto.shippedQty === null) {
          shippedQty = '';
      } else {
        shippedQty = pdto.shippedQty;
      }

        if (pdto.msoPayerAccount === null) {
        msoPayerAccount = '';
      } else {
        msoPayerAccount = pdto.msoPayerAccount;
      }

        createDateTime = this.datePipe.transform(pdto.poDate, this.appSettingService.globelDateFormat);
        bolDate = this.datePipe.transform(pdto.bolDate, this.appSettingService.globelDateFormat);
        this.poReportDto.push({
         'PO Date': `` + createDateTime, PO: `${pdto.poNumber}`,
         AxaltaCartKey  : `${pdto.axaltaCartKey}`, BoL: `` + bol ,
         'BoL Date' : `` + bolDate, ' Invoice Number'  : `` + invoiceNumber,
         'Distributor Payer#' : `${pdto.distributorPayerNumber}`,
         'Partner Name' : `${pdto.partnerName}`,
         'MSO Entity Name' : `${pdto.msoEntityName}`,
           'MSO Payer Account' : `` + msoPayerAccount,
           'Status ' : `${pdto.refCodeName}`,  'Order Quantity' : `${pdto.orderedQty}`,
           'Shipped Quantity ' : `` + shippedQty
         });
     });

 this.exportFileName();
 this.excelFileService.exportPbjReortWothPoReportExcel(this.selectedPbjReportDto, this.poReportDto , this.exportFileNameStr);
       }
      } else {

    if (this.mlrExportModal === 'PDF') {
      this.exportFileName();
      this.pdfFileService.exportPbjDashboard(this.exportFileNameStr, this.poandPBJreportDto);
    } else if (this.mlrExportModal === 'Excel') {
      this.selectedPbjReportDto = [];
      this.fileExportService.selectedPbjReportData.forEach(pdto => {
        if (pdto.rowCheck) {
         let createDateTime: any;
         createDateTime = this.datePipe.transform(pdto.dateOfCount, this.appSettingService.globelDateFormat);
         this.selectedPbjReportDto.push({
            Date: `` + createDateTime, PO: `${pdto.repCountofPO}`,
            'BoL' : `${pdto.repCountBol}`,
            Invoice : `${pdto.repCountInvoice}`, P2B : `${pdto.repCountBolNotReceived}`,
            B2I : `${pdto.repCountB2I}`, 'Sum of Shipped Qty 0' : `${pdto.repCountShippedZero}`,
          });
        }
      });

      this.poReportDto = [];
      this.poandPBJreportDto.poReportList.forEach(pdto => {
        let createDateTime: any;
        let bolDate: any;
        let bol: any;
        let invoiceNumber: any;
        let shippedQty: any;
        let msoPayerAccount: any;
        if (pdto.supplierDocReferenceNumber === null) {
          bol = '';
       } else {
        bol = pdto.supplierDocReferenceNumber;
       }

        if (pdto.invoiceNumber === null) {
        invoiceNumber = '';
      } else {
        invoiceNumber = pdto.invoiceNumber;
      }

        if (pdto.shippedQty === null) {
          shippedQty = '';
      } else {
        shippedQty = pdto.shippedQty;
      }

        if (pdto.msoPayerAccount === null) {
        msoPayerAccount = '';
      } else {
        msoPayerAccount = pdto.msoPayerAccount;
      }

        createDateTime = this.datePipe.transform(pdto.poDate, this.appSettingService.globelDateFormat);
        bolDate = this.datePipe.transform(pdto.bolDate, this.appSettingService.globelDateFormat);
        createDateTime = this.datePipe.transform(pdto.poDate, this.appSettingService.globelDateFormat);
        bolDate = this.datePipe.transform(pdto.bolDate, this.appSettingService.globelDateFormat);
        this.poReportDto.push({
         'PO Date': `` + createDateTime, PO: `${pdto.poNumber}`,
         AxaltaCartKey  : `${pdto.axaltaCartKey}`, BoL: `` + bol ,
         'BoL Date' : `` + bolDate, ' Invoice Number'  : `` + invoiceNumber,
         'Distributor Payer#' : `${pdto.distributorPayerNumber}`,
         'Partner Name' : `${pdto.partnerName}`,
         'MSO Entity Name' : `${pdto.msoEntityName}`,
           'MSO Payer Account' : `` + msoPayerAccount,
           'Status ' : `${pdto.refCodeName}`,  'Order Quantity' : `${pdto.orderedQty}`,
           'Shipped Quantity ' : `` + shippedQty
         });
      });

      this.exportFileName();
      this.excelFileService.exportPbjReortWothPoReportExcel(this.selectedPbjReportDto,this.poReportDto , this.exportFileNameStr);
    }
  }
}
}
/****************************************************** File Export End ***************************************************/


/****************************************************** Table Sort Start ***************************************************/
ChangeMlrSortOrder(exportData) {
  this.mlrExportModal = exportData;
}

onChangeSortPbjr(event: any, upDown: boolean, propertyName: string) {
  if (propertyName === 'dateOfCount' ) {
    this.isPoUpArrow = true;
    this.isPoDownArrow = true;
    this.isPoNobolUpArrow = true;
    this.isPoNobolDownArrow = true;
    this.isPoPartialUpArrow = true;
    this.isPoPartialDownArrow = true;
    this.isPoCompleteUpArrow = true;
    this.isPoCompleteDownArrow = true;
    this.isBolUpArrow = true;
    this.isBolDownArrow = true;
    this.isInvoiceUpArrow = true;
    this.isInvoiceDownArrow = true;
    this.isP2bUpArrow = true;
    this.isP2bDownArrow = true;
    this.isB2iUpArrow = true;
    this.isB2iDownArrow = true;
    this.isSumOfShippedQtyUpArrow = true;
    this.isSumOfShippedQtyDownArrow = true;
    if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, upDown);
  this.pbjReportDtoList = [];
  this.pbjReportDtoList = this.sortArry;
  this.isDateUpArrow = !this.isDateUpArrow;
  this.isDateDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, upDown);
this.pbjReportDtoList = [];
this.pbjReportDtoList = this.sortArry;
this.isDateDownArrow = !this.isDateDownArrow;
this.isDateUpArrow = true;
}
} else if (propertyName === 'repCountofPO' ) {
  this.isDateUpArrow = true;
  this.isDateDownArrow = true;
  this.isPoNobolUpArrow = true;
  this.isPoNobolDownArrow = true;
  this.isPoPartialUpArrow = true;
  this.isPoPartialDownArrow = true;
  this.isPoCompleteUpArrow = true;
  this.isPoCompleteDownArrow = true;
  this.isBolUpArrow = true;
  this.isBolDownArrow = true;
  this.isInvoiceUpArrow = true;
  this.isInvoiceDownArrow = true;
  this.isP2bUpArrow = true;
  this.isP2bDownArrow = true;
  this.isB2iUpArrow = true;
  this.isB2iDownArrow = true;
  this.isSumOfShippedQtyUpArrow = true;
  this.isSumOfShippedQtyDownArrow = true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, true);
  this.pbjReportDtoList = [];
  this.pbjReportDtoList = this.sortArry;
  this.isPoUpArrow = !this.isPoUpArrow;
  this.isPoDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, false);
this.pbjReportDtoList = [];
this.pbjReportDtoList = this.sortArry;
this.isPoDownArrow = !this.isPoDownArrow;
this.isPoUpArrow = true;
}
} else if (propertyName === 'no' ) {
  this.isDateUpArrow = true;
  this.isDateDownArrow = true;
  this.isPoUpArrow = true;
  this.isPoDownArrow = true;
  this.isPoPartialUpArrow = true;
  this.isPoPartialDownArrow = true;
  this.isPoCompleteUpArrow = true;
  this.isPoCompleteDownArrow = true;
  this.isBolUpArrow = true;
  this.isBolDownArrow = true;
  this.isInvoiceUpArrow = true;
  this.isInvoiceDownArrow = true;
  this.isP2bUpArrow = true;
  this.isP2bDownArrow = true;
  this.isB2iUpArrow = true;
  this.isB2iDownArrow = true;
  this.isSumOfShippedQtyUpArrow = true;
  this.isSumOfShippedQtyDownArrow = true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, true);
  this.pbjReportDtoList = [];
  this.pbjReportDtoList = this.sortArry;
  this.isPoNobolUpArrow = !this.isPoNobolUpArrow;
  this.isPoNobolDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, false);
this.pbjReportDtoList = [];
this.pbjReportDtoList = this.sortArry;
this.isPoNobolDownArrow = !this.isPoNobolDownArrow;
this.isPoNobolUpArrow = true;
}
} else if (propertyName === 'repCountpartialOrders' ) {
  this.isDateUpArrow = true;
  this.isDateDownArrow = true;
  this.isPoUpArrow = true;
  this.isPoDownArrow = true;
  this.isPoNobolUpArrow = true;
  this.isPoNobolDownArrow = true;
  this.isPoCompleteUpArrow = true;
  this.isPoCompleteDownArrow = true;
  this.isBolUpArrow = true;
  this.isBolDownArrow = true;
  this.isInvoiceUpArrow = true;
  this.isInvoiceDownArrow = true;
  this.isP2bUpArrow = true;
  this.isP2bDownArrow = true;
  this.isB2iUpArrow = true;
  this.isB2iDownArrow = true;
  this.isSumOfShippedQtyUpArrow = true;
  this.isSumOfShippedQtyDownArrow = true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, true);
  this.pbjReportDtoList = [];
  this.pbjReportDtoList = this.sortArry;
  this.isPoPartialUpArrow = !this.isPoPartialUpArrow;
  this.isPoPartialDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, false);
this.pbjReportDtoList = [];
this.pbjReportDtoList = this.sortArry;
this.isPoPartialDownArrow = !this.isPoPartialDownArrow;
this.isPoPartialUpArrow = true;
}
} else if (propertyName === 'repCountCompleteOrders' ) {
  this.isDateUpArrow = true;
  this.isDateDownArrow = true;
  this.isPoUpArrow = true;
  this.isPoDownArrow = true;
  this.isPoNobolUpArrow = true;
  this.isPoNobolDownArrow = true;
  this.isPoPartialUpArrow = true;
  this.isPoPartialDownArrow = true;
  this.isBolUpArrow = true;
  this.isBolDownArrow = true;
  this.isInvoiceUpArrow = true;
  this.isInvoiceDownArrow = true;
  this.isP2bUpArrow = true;
  this.isP2bDownArrow = true;
  this.isB2iUpArrow = true;
  this.isB2iDownArrow = true;
  this.isSumOfShippedQtyUpArrow = true;
  this.isSumOfShippedQtyDownArrow = true;

  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, true);
  this.pbjReportDtoList = [];
  this.pbjReportDtoList = this.sortArry;
  this.isPoCompleteUpArrow = !this.isPoCompleteUpArrow;
  this.isPoCompleteDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, false);
this.pbjReportDtoList = [];
this.pbjReportDtoList = this.sortArry;
this.isPoCompleteDownArrow = !this.isPoCompleteDownArrow;
this.isPoCompleteUpArrow = true;
}
} else if (propertyName === 'repCountBol' ) {
  this.isDateUpArrow = true;
  this.isDateDownArrow = true;
  this.isPoUpArrow = true;
  this.isPoDownArrow = true;
  this.isPoNobolUpArrow = true;
  this.isPoNobolDownArrow = true;
  this.isPoPartialUpArrow = true;
  this.isPoPartialDownArrow = true;
  this.isPoCompleteUpArrow = true;
  this.isPoCompleteDownArrow = true;
  this.isInvoiceUpArrow = true;
  this.isInvoiceDownArrow = true;
  this.isP2bUpArrow = true;
  this.isP2bDownArrow = true;
  this.isB2iUpArrow = true;
  this.isB2iDownArrow = true;
  this.isSumOfShippedQtyUpArrow = true;
  this.isSumOfShippedQtyDownArrow = true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, true);
  this.pbjReportDtoList = [];
  this.pbjReportDtoList = this.sortArry;
  this.isBolUpArrow = !this.isBolUpArrow;
  this.isBolDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, false);
this.pbjReportDtoList = [];
this.pbjReportDtoList = this.sortArry;
this.isBolDownArrow = !this.isBolDownArrow;
this.isBolUpArrow = true;
}
} else if (propertyName === 'repCountInvoice' ) {
  this.isDateUpArrow = true;
  this.isDateDownArrow = true;
  this.isPoUpArrow = true;
  this.isPoDownArrow = true;
  this.isPoNobolUpArrow = true;
  this.isPoNobolDownArrow = true;
  this.isPoPartialUpArrow = true;
  this.isPoPartialDownArrow = true;
  this.isPoCompleteUpArrow = true;
  this.isPoCompleteDownArrow = true;
  this.isP2bUpArrow = true;
  this.isP2bDownArrow = true;
  this.isB2iUpArrow = true;
  this.isB2iDownArrow = true;
  this.isSumOfShippedQtyUpArrow = true;
  this.isSumOfShippedQtyDownArrow = true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, true);
  this.pbjReportDtoList = [];
  this.pbjReportDtoList = this.sortArry;
  this.isInvoiceUpArrow = !this.isInvoiceUpArrow;
  this.isInvoiceDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, false);
this.pbjReportDtoList = [];
this.pbjReportDtoList = this.sortArry;
this.isInvoiceDownArrow = !this.isInvoiceDownArrow;
this.isInvoiceUpArrow = true;
}
} else if (propertyName === 'repCountBolNotReceived' ) {
  this.isDateUpArrow = true;
  this.isDateDownArrow = true;
  this.isPoUpArrow = true;
  this.isPoDownArrow = true;
  this.isPoNobolUpArrow = true;
  this.isPoNobolDownArrow = true;
  this.isPoPartialUpArrow = true;
  this.isPoPartialDownArrow = true;
  this.isPoCompleteUpArrow = true;
  this.isPoCompleteDownArrow = true;
  this.isInvoiceUpArrow = true;
  this.isInvoiceDownArrow = true;
  this.isB2iUpArrow = true;
  this.isB2iDownArrow = true;
  this.isSumOfShippedQtyUpArrow = true;
  this.isSumOfShippedQtyDownArrow = true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, true);
  this.pbjReportDtoList = [];
  this.pbjReportDtoList = this.sortArry;
  this.isP2bUpArrow = !this.isP2bUpArrow;
  this.isP2bDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, false);
this.pbjReportDtoList = [];
this.pbjReportDtoList = this.sortArry;
this.isP2bDownArrow = !this.isP2bDownArrow;
this.isP2bUpArrow = true;
}
} else if (propertyName === 'repCountB2I' ) {
  this.isDateUpArrow = true;
  this.isDateDownArrow = true;
  this.isPoUpArrow = true;
  this.isPoDownArrow = true;
  this.isPoNobolUpArrow = true;
  this.isPoNobolDownArrow = true;
  this.isPoPartialUpArrow = true;
  this.isPoPartialDownArrow = true;
  this.isPoCompleteUpArrow = true;
  this.isPoCompleteDownArrow = true;
  this.isInvoiceUpArrow = true;
  this.isInvoiceDownArrow = true;
  this.isP2bUpArrow = true;
  this.isP2bDownArrow = true;
  this.isSumOfShippedQtyUpArrow = true;
  this.isSumOfShippedQtyDownArrow = true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, true);
  this.pbjReportDtoList = [];
  this.pbjReportDtoList = this.sortArry;
  this.isB2iUpArrow = !this.isB2iUpArrow;
  this.isB2iDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, false);
this.pbjReportDtoList = [];
this.pbjReportDtoList = this.sortArry;
this.isB2iDownArrow = !this.isB2iDownArrow;
this.isB2iUpArrow = true;
}
} else if (propertyName === 'repCountShippedZero' ) {
  this.isDateUpArrow = true;
  this.isDateDownArrow = true;
  this.isPoUpArrow = true;
  this.isPoDownArrow = true;
  this.isPoNobolUpArrow = true;
  this.isPoNobolDownArrow = true;
  this.isPoPartialUpArrow = true;
  this.isPoPartialDownArrow = true;
  this.isPoCompleteUpArrow = true;
  this.isPoCompleteDownArrow = true;
  this.isInvoiceUpArrow = true;
  this.isInvoiceDownArrow = true;
  this.isP2bUpArrow = true;
  this.isP2bDownArrow = true;
  this.isB2iUpArrow = true;
  this.isB2iDownArrow = true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, true);
  this.pbjReportDtoList = [];
  this.pbjReportDtoList = this.sortArry;
  this.isSumOfShippedQtyUpArrow = !this.isSumOfShippedQtyUpArrow;
  this.isSumOfShippedQtyDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.pbjReportDtoList, propertyName, false);
this.pbjReportDtoList = [];
this.pbjReportDtoList = this.sortArry;
this.isSumOfShippedQtyDownArrow = !this.isSumOfShippedQtyDownArrow;
this.isSumOfShippedQtyUpArrow = true;
}
}

}

/****************************************************** Table Sort End ***************************************************/



/****************************************************** Row Selection Start ***************************************************/
  onSelectParticularRowPbjr(selectedItem: any, values: any) {
  if (values.currentTarget.checked) {
    this.fileExportService.selectedPbjReportData.push(selectedItem);
  } else if (!values.currentTarget.checked) {
    this.fileExportService.selectedPbjReportData =
    this.fileExportService.selectedPbjReportData.filter(obj => obj !== selectedItem);
  }
  if (this.fileExportService.selectedPbjReportData.length === this.pbjReportDtoList.length) {
    this.mlrSelectAllRowModal = true;
  } else {
    this.mlrSelectAllRowModal = false;
  }
}

onSelectAllRowPbjr(values: any) {
this.pbjReportDtoSelectedList = [];
if (values.currentTarget.checked) {
  this.pbjReportDtoList.forEach(pdto => {
    pdto.rowCheck = true;
    this.pbjReportDtoSelectedList.push(pdto);
  });
  this.pbjReportDtoList = this.pbjReportDtoSelectedList;
  this.fileExportService.selectedPbjReportData = this.pbjReportDtoSelectedList;
} else {
  this.pbjReportDtoList.forEach(pdto => {
    pdto.rowCheck = false;
    this.pbjReportDtoSelectedList.push(pdto);
  });
  this.pbjReportDtoList = this.pbjReportDtoSelectedList;
  this.fileExportService.selectedPbjReportData = [];
}
}
/****************************************************** Row Selection End ***************************************************/


/****************************************************** Pagination Start ***************************************************/
onChangePaginationPbjr(value) {

  this.paginationConfigurationPbjr.itemsPerPage = value;
  this.mlrPaginationcount = value;
}

pageOnChangedPbjr(event) {
  this.paginationConfigurationPbjr.currentPage = event;
}
/****************************************************** Pagination End ***************************************************/



}
